import React from "react"
import GroupGameTableRowCell from "./GroupGameTableRowCell";

export default function GroupGameTableRow(props) {
    function getCardName(cellNumber) {
        return props.cards[cellNumber - 1]?.title
    }

    return (
        <tr>
            {
                props.row_data.map(
                    (item) => <GroupGameTableRowCell
                        key={item.id}
                        cellNumber={item.id}
                        cellTitle={getCardName(item.id)}
                        fieldStyle={props.fieldStyle}
                        gameState={props.gameState}
                        selectedPlayerId={props.selectedPlayerId}
                    />
                )
            }
        </tr>
    )
}
